import _get from "lodash/get";
import styled, { css } from 'styled-components';
import { transparentize, rem } from 'polished';
import horizontalScrollTheme from '../styles/horizontalScrollTheme';
var Fade = styled.div.withConfig({
  displayName: "Fade",
  componentId: "sc-1kcmtz4-0"
})(["height:", ";pointer-events:none;position:absolute;top:0;width:", ";z-index:3;", " ", " ", " ", " ", " ", ""], function (_ref) {
  var theme = _ref.theme;
  return "calc(\n                    100% -\n                        " + rem(_get(theme, 'horizontalScroll.scrollbar.height', horizontalScrollTheme.horizontalScroll.scrollbar.height)) + "\n                )";
}, function (_ref2) {
  var theme = _ref2.theme,
      fadeWidth = _ref2.fadeWidth;
  return rem(fadeWidth || _get(theme, 'horizontalScroll.fadeWidth', horizontalScrollTheme.horizontalScroll.fadeWidth));
}, function (_ref3) {
  var showEnd = _ref3.showEnd;
  return showEnd && css(["right:0;"]);
}, function (_ref4) {
  var showStart = _ref4.showStart;
  return showStart && css(["left:0;"]);
}, function (_ref5) {
  var fadeColor = _ref5.fadeColor,
      showStart = _ref5.showStart;
  return fadeColor && showStart && css(["background:linear-gradient(to left,", ",", ");"], transparentize(100, fadeColor), fadeColor);
}, function (_ref6) {
  var fadeColor = _ref6.fadeColor,
      showEnd = _ref6.showEnd;
  return fadeColor && showEnd && css(["background:linear-gradient(to right,", ",", ");"], transparentize(100, fadeColor), fadeColor);
}, function (_ref7) {
  var fadeColor = _ref7.fadeColor,
      showStart = _ref7.showStart,
      theme = _ref7.theme;
  return !fadeColor && showStart && css(["background:linear-gradient( to left,", ",", " );"], transparentize(100, _get(theme, 'horizontalScroll.fadeColor', horizontalScrollTheme.horizontalScroll.fadeColor)), _get(theme, 'horizontalScroll.fadeColor', horizontalScrollTheme.horizontalScroll.fadeColor));
}, function (_ref8) {
  var fadeColor = _ref8.fadeColor,
      showEnd = _ref8.showEnd,
      theme = _ref8.theme;
  return !fadeColor && showEnd && css(["background:linear-gradient( to right,", ",", " );"], transparentize(100, _get(theme, 'horizontalScroll.fadeColor', horizontalScrollTheme.horizontalScroll.fadeColor)), _get(theme, 'horizontalScroll.fadeColor', horizontalScrollTheme.horizontalScroll.fadeColor));
});
export default Fade;